(function (app) {
    var ItemModel = Backbone.Model.extend({
        idAttribute: 'ID',
        initialize: function (data) {
            this.set('ImgUrl', GlobalSettings.SecureImageServerURL + 'brands/' + data.BrandID + '/' + data.ImageID + '/' + data.FileName);

            this.set('ProductLink', globalUrls.product + 'saleID=' + kos.guidToBase64(data.SaleID) + '&productID=' + kos.guidToBase64(data.ItemID));

            this.set('PriceStr', window.toMoney(data.Price, GlobalSettings.CurrencySign));
            this.set('SubtotalStr', window.toMoney(data.Subtotal, GlobalSettings.CurrencySign));

            var multibuyDescription = '[[Price]] for each item when you purchase [[Count]] or more products in this sale';
            if (!data.Discount) {
                this.set('MultiBuyDiscount', window.toMoney((data.MultiBuyDiscountPrice / data.MultiBuyCount) * data.Qty, GlobalSettings.CurrencySign));
                this.set('MultiBuyActive', false);
            } else {
                this.set('MultiBuyDiscount', window.toMoney(data.SubtotalWithDiscount, GlobalSettings.CurrencySign));
                this.set('MultiBuyActive', true);
            }
            var description = multibuyDescription
                .replace(/\[\[Price\]\]/gi, window.toMoney(data.MultiBuyDiscountPrice / data.MultiBuyCount, GlobalSettings.CurrencySign))
                .replace(/\[\[Count\]\]/gi, data.MultiBuyCount);
            this.set('MultiBuyDescription', description);

            var displayDiscount = data.SubtotalWithDiscount &&
                data.SubtotalWithDiscount > 0 &&
                data.DiscountPercentOff &&
                data.DiscountPercentOff > 0;

            this.set('DisplayDiscount', displayDiscount);
            if (displayDiscount) {
                this.set('DiscountAmount', window.toMoney(data.SubtotalWithDiscount, GlobalSettings.CurrencySign));
                this.set('DiscountPercentOff', data.DiscountPercentOff);
            }
        },
        increase: function () {
            // if (this.get('Qty') < 5)
                return app.checkout.increaseItemQty(this);
            // return new $.Deferred().reject().promise();
        },
        decrease: function () {
            return app.checkout.decreaseItemQty(this);
        },
        delete: function () {
            return app.checkout.deleteItemQty(this);
        }
    });

    var ItemsCollection = Backbone.Collection.extend({
        model: ItemModel,
        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function (data) {
            this._display = !data.UseLocationDeliveryPriceSettings;
            this.update(data.Items);
        }
    });

    var ShipmentItemsCollection = Backbone.Collection.extend({
        model: ItemModel,
        initialize: function () {
            this._display = true;
        }
    });

    var ShipmentModel = Backbone.Model.extend({
        initialize: function (data) {
            this.set('DeliveryPriceSrc', data.DeliveryPrice === null ? null : window.toMoney(data.DeliveryPrice, GlobalSettings.CurrencySign));
            this.set('Items', new ShipmentItemsCollection(data.Items));
            this.set('AmountToPromoPriceSrc', window.toMoney(data.AmountToPromoPrice, GlobalSettings.CurrencySign));
            if (data.PromoPriceThresholdSource === 3) {
                this.set('LinkToProducts', "/ItemsList.aspx?saleID=" + kos.guidToBase64(data.SaleId));
            } else {
                this.set('LinkToProducts', "/shop/other-products/" + data.LocationFilterHash);
            }
        }
    });

    var ShipmentsCollection = Backbone.Collection.extend({
        model: ShipmentModel,
        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function (data) {
            var list = [];
            this._display = data.UseLocationDeliveryPriceSettings;
            if (data.UseLocationDeliveryPriceSettings) {
                _.each(data.Shipments, function(shipment) {
                    var items = [];
                    _.each(shipment.Items, function(ID) {
                        var item = _.findWhere(data.Items, {ID: ID});
                        item && items.push(item);
                    });
                    shipment.Items = items;
                    list.push(shipment);
                });
            }
            this.update(list);
        },
        shippingAvailability: function() {
            return !(app.models.shipmentList.where({ 'ShippingAvailability': false }).length > 0);
        }
    });

    app.models = _.extend({ itemsList: new ItemsCollection(), shipmentList: new ShipmentsCollection() }, app.models);
})(app);